import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useDispatch } from "react-redux";

import { Grid, TextField, Typography } from '@material-ui/core';

import MyAutoComplete from '../../../../utils/MyAutoComplete';
import { formatStringToDisplay, parseFloatByPtCurrency } from '../../../../utils/utils';
import { FundAPI } from '../../../../../API/fund';
import { myLabelInput, unoTheme } from '../../../../../assets/styles/unoTheme';
import UnoButton from '../../../../utils/UnoButton';
import MyTextField from '../../../../utils/MyTextField';
import allActions from '../../../../../actions';
import { getLocalInfosByListFunds } from '../../../../../controllers/FundLocalQuotasController';
import { FundLocalQuotasAPI } from '../../../../../API/fund_local_quotas';

// const Transition = React.forwardRef(function Transition(props, ref) {
//     return <Slide direction="up" ref={ref} {...props} />;
// });

const useStyles = makeStyles((theme) => ({
    contentModal: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        alignItems: 'center',
        paddingBottom: theme.spacing(4),
    },

    actionsFlex: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },

    actionsFlexRight: {
        display: 'flex',
        alignItems: 'center',
    },

    spacingRight2: {
        marginRight: theme.spacing(2),
    },
    formControl: {
        //margin: theme.spacing(1), 
        width: '100%',
        textAlign: 'left'
    },
    dialogTitle: {
        '& h2': {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            //justifyContent: 'space-between'
        }

    },
    noMarginTop: {
        marginTop: "0px",
    },
    tableTh: {
        fontWeight: 'bold'
    },
    assetsToCreateRow: {
        '& .MuiTableCell-root': {
            fontSize: '12px !important',
        }
    },
    green: {
        color: unoTheme.greenMoney,
    },
    red: {
        color: unoTheme.redMoney,
    },
    blue: {
        color: "blue",
    },
    warningColor: {
        color: unoTheme.warningColor
    },
    label: myLabelInput,
    afirmativeText: {
        color: 'black'
    },
    noPaddingLeft: {
        paddingLeft: '0px',
    },
    noPaddingRight: {
        paddingRight: '0px !important',
    },

    progress: {
        color: unoTheme.mainColor,
        textAlign: 'center',
        '& .MuiCircularProgress-root': {
            width: '25px !important',
            height: '25px !important',
        },

        '& h6': {
            fontSize: '14px !important',
        }
    },

    greenInput: {
        '& input': {
            color: unoTheme.greenMoney,
        }
    },


}));

export default function AddFundAlocationModal(props) {

    const dispatch = useDispatch();
    const classes = useStyles();
    const history = useHistory();

    const { open, currentFundsIds, period,
        handleAction } = props;

    const [submitted, setSubmitted] = useState(false);

    const [allFunds, setAllFunds] = useState(null);

    const [fundSelected, setFundSelected] = useState(null);
    const [initApplication, setInitApplication] = useState('0,00');

    const doGetAllFunds = async () => {
        const responseAllFunds = await FundAPI.getAllFunds();

        if (responseAllFunds.success) {
            setAllFunds(responseAllFunds.body.rows)
        }
    }

    const loadFullDataAddedFund = async (fund) => {

        //console.log("Loading full data for fund: ", fund);
        const response = await FundAPI.getSimpleFundById(fund.id, null, period)
        if (response.success) {

            //console.log("Response fund by id: ", response);
            const addedFund = response.body.rows[0];
            //console.log("End date: ", period);
            const info = await FundLocalQuotasAPI.getLastLocalFundInfoByFundId(fund.id);
            const infoFormatted = JSON.parse(info.body.rows[0].json_fund_infos);

            //console.log("Info: ", info);

            return {
                ...response.body.rows[0],
                ...infoFormatted,
            };

        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: "error",
                message: "Falha ao obter informações do fundo selecionado",
            }))

            return null;

        }

    }

    const handleAddFund = async (fund, application) => {

        setSubmitted(true);
        if (fund && !currentFundsIds.includes(fund.id)) {

            const responseFundFull = await loadFullDataAddedFund(fund);
            console.log("responseFundFull: ", responseFundFull);
            if (responseFundFull) {
                handleAction(responseFundFull, parseFloatByPtCurrency(application))
            }
        }

    }

    useEffect(() => {

        if (!allFunds && open) {
            doGetAllFunds();
        }

        if (!open) {
            setFundSelected(null)
            setInitApplication("0,00")
            setSubmitted(false)
        }

    }, [open])

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'sm'}
            open={open}
            onClose={() => handleAction(false)}>
            <DialogTitle
                className={classes.dialogTitle}>
                {"Adicionar fundo"}
            </DialogTitle>

            <DialogContent
                className={classes.contentModal}>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <MyAutoComplete
                            outerlabel={"Fundo"}
                            onChange={(event, newValue) => {
                                console.log("New value: ", newValue);
                                setFundSelected(newValue);
                            }}
                            // customWidth={'380px'}
                            options={allFunds}
                            autoComplete
                            label={'Nome do fundo ou CNPJ'}
                            filterOptions={(options, state) => {
                                if (!options) return [];
                                return options.filter(element => element.cnpj
                                    .includes(state.inputValue)
                                    || element.fund_name.toLowerCase().includes(state.inputValue.toLowerCase()));
                            }}
                            value={fundSelected ? fundSelected : null}
                            getOptionLabel={(option) => formatStringToDisplay(option.fund_name, 5, '...')}
                            validator={(fundSelected == null || (fundSelected != null && currentFundsIds.includes(fundSelected.id))) && submitted ? true : false}
                            helperText={fundSelected && currentFundsIds.includes(fundSelected.id) ? "O fundo já consta na carteira do cliente" : "Informe o fundo"}
                            renderOption={(option) => (
                                <React.Fragment key={'add-fund-alocation-' + option.id}>
                                    <span className={classes.bold}>{option.fund_name}</span>
                                </React.Fragment>
                            )}
                            renderInput={(params) => <TextField {...params} margin="normal" variant="outlined" />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <MyTextField
                            outerlabel={"Aplicação inicial"}
                            className={classes.greenInput}
                            id={"applictions-init-add-fund"}
                            mask={["currency"]}
                            align="right"
                            labelclassname={classes.noMarginTop}
                            value={initApplication}
                            onChange={(value) => setInitApplication(value)}
                            fullWidth />
                    </Grid>
                </Grid>




            </DialogContent>

            <DialogActions className={classes.actionsFlex}>

                <UnoButton onClick={() =>
                    handleAction(false)} color="secondary">
                    {'Cancelar'}
                </UnoButton>

                <UnoButton
                    className={classes.spaceRight2}
                    onClick={() => handleAddFund(fundSelected, initApplication)}
                    color="primary">
                    {"Confirmar"}
                </UnoButton>

            </DialogActions>

        </Dialog>
    );
}